import { DatePicker } from '@bp/ui-components';
import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import { useEffect, useMemo } from 'react';
import { HolidayType } from '../graphql';

type DatePickerHolidaysFieldProps = {
  label: string;
  fieldName: 'end' | 'start';
  updateEnd: boolean;
};

export const DatePickerHolidaysField = ({ label, fieldName, updateEnd }: DatePickerHolidaysFieldProps) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } = useFormikContext<HolidayType>();

  const newEnd = useMemo(() => {
    return dayjs(values.start).utc(true).add(1, 'days').toDate();
  }, [values.start]);

  //biome-ignore lint/correctness/useExhaustiveDependencies(setFieldValue): ignore setFieldValue
  useEffect(() => {
    if (fieldName === 'start' && touched.start && !touched.end && updateEnd) {
      setFieldValue('end', newEnd, true);
    }
  }, [fieldName, newEnd, updateEnd, touched.end, touched.start]);

  return (
    <DatePicker
      label={label}
      name={fieldName}
      onChange={(date) => {
        setFieldTouched(fieldName, true);
        setFieldValue(fieldName, dayjs(date).utc(true).toDate());
      }}
      value={values[fieldName]}
      error={errors[fieldName] as string}
      showIcon
    />
  );
};
